import {
  CLOUDER_CATEGORIES,
  CLOUDER_CATEGORIES_OPTIONS,
} from '@wareclouds/frontend-common';
import { getTrend } from './getTrend';

export function mapSemiMonthlySummaryResponse(response) {
  const payload = response?.data || {};

  const summary = payload.summary || {};
  const periods = payload.periods || {};
  const classification = payload.classification || {};

  return {
    periods: {
      selected: periods.selected || null,
      previous: periods.previous || null,
    },

    classification: {
      current:
        CLOUDER_CATEGORIES_OPTIONS[
          CLOUDER_CATEGORIES[classification.current]
        ] || null,
      next:
        CLOUDER_CATEGORIES_OPTIONS[CLOUDER_CATEGORIES[classification.next]] ||
        null,
    },

    metrics: {
      totalPayment: normalizeMetric(summary.total_payment),
      onTimeDeliveries: normalizeMetric(summary.on_time_deliveries),
      routesCompleted: normalizeMetric(summary.routes_completed),
      protestedDeliveries: normalizeMetric(summary.protested_deliveries),
      returns: normalizeMetric(summary.returns),
      delayedReturns: normalizeMetric(summary.delayed_returns),
      customerRating: normalizeMetric(summary.customer_rating),
    },

    earnings: {
      routes: normalizeMetric(summary.routes_earnings),
      performanceBonus: normalizeMetric(summary.performance_bonus),
      multiplePackages: normalizeMetric(summary.multiple_packages),
      largePackages: normalizeMetric(summary.large_packages_earnings),
      settlements: normalizeMetric(summary.settlements_and_discounts),
      pendingPayment: normalizeMetric(summary.pending_payment),
      firstWeekBonus: normalizeMetric(summary.first_week_bonus),
    },
  };
}

function normalizeMetric(metric) {
  return {
    current: metric?.current ?? 0,
    previous: metric?.previous ?? 0,
    trend: getTrend(metric?.current, metric?.previous),
  };
}
